module.exports = __webpack_public_path__ + "static/media/YF105_1.ab3c3195.jpg";